import { Box, CardContent, Typography, useTheme } from '@mui/material';
import { format } from 'date-fns';
import DOMPurify from 'dompurify';
import { Noticia } from '../../../../../typesSite/noticia/Noticia';

import { gerarUrlCapa } from '../create/gerarUrlCapa';
import SocialShareButtons from './SocialShareButtons';

type Props = {
  noticia: Noticia | undefined;
};

export function NoticiaViewForm({ noticia }: Props) {
  const theme = useTheme();

  return (
    <Box
      mb={2}
      mt={3}
      sx={{
        width: '100%',
        maxWidth: '900px',
        mx: 'auto',
        px: { xs: 2, sm: 3, md: 4 }
      }}
    >
      {/* Título */}
      <Typography
        sx={{
          color: theme.custom.noticia.textTitle.color,
          
          fontFamily: theme.custom.noticia.textTitle.font,
          fontWeight: theme.custom.noticia.textTitle.fontWeight,
          fontSize: { xs: '20px', sm: '24px', md: '28px' }, // responsivo
          lineHeight: { xs: '28px', sm: '32px', md: '36px' }
        }}
      >
        {noticia?.titulo}
      </Typography>

      {/* Resumo 
      <Box mt={2}>
        <Typography
          sx={{
            color: theme.custom.noticia.textResume.color,
            fontFamily: theme.custom.noticia.textResume.font,
            fontWeight: theme.custom.noticia.textResume.fontWeight,
            fontSize: { xs: '14px', sm: '16px', md: '18px' },
            lineHeight: { xs: '20px', sm: '22px', md: '26px' },
          }}
        >
          {noticia?.resumo}
        </Typography>
      </Box>
      */}

      {/* Autor e Data */}
      <Box mt={2} display="flex" justifyContent="flex-end">
        <Typography
          sx={{
            color: theme.custom.noticia.textAuthor.color,
            fontFamily: theme.custom.noticia.textAuthor.font,
            fontWeight: theme.custom.noticia.textAuthor.fontWeight,
            fontSize: { xs: '12px', sm: '13px', md: '14px' },
            fontStyle: theme.custom.noticia.textAuthor.fontStyle
          }}
        >
          Por: {noticia?.usuario.nome} &nbsp;•&nbsp; {noticia?.dataHoraCriacao ? format(noticia.dataHoraCriacao, 'dd/MM/yyyy') : 'Data não disponível'}
        </Typography>
      </Box>

      {/* rede social */}
      <Box mt={2} display="flex" justifyContent="flex-end">
        <SocialShareButtons title={noticia?.titulo} />
      </Box>

      {/* Imagem */}
      {noticia?.imagem && (
        <Box mt={4} display="flex" justifyContent="center">
          <Box
            component="img"
            src={gerarUrlCapa(noticia.imagem, 'NOTICIA')}
            alt="Capa da Notícia"
            sx={{
              width: '100%',
              maxWidth: { xs: '100%', sm: '700px', md: '800px' }, // Limita no desktop
              height: 'auto', // Ajusta a altura automaticamente conforme a proporção
              maxHeight: { xs: '100%', sm: '350px', md: '400px' }, // Limita a altura máxima
              objectFit: 'contain', // Ajusta para não cortar ou distorcer
              borderRadius: 2
            }}
            className="noticia-image"
          />
        </Box>
      )}

      {/* Corpo da notícia */}
      <Box mt={3}>
        <Typography
          component="div"
          textAlign="justify"
          sx={{
            fontSize: { xs: '15px', sm: '16px', md: '18px' },
            lineHeight: { xs: '22px', sm: '24px', md: '28px' },
            color: theme.custom.noticia.textBody.color,
            fontFamily: theme.custom.noticia.textBody.font,
            fontWeight: theme.custom.noticia.textBody.fontWeight
          }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(noticia ? noticia.corpo : '')
          }}
        />
      </Box>
    </Box>
  );
}
